import { Checkbox } from '../ui/checkbox';
import { Label } from '../ui/label';
import { Section, FieldLabel } from './FormPrimitives';
import ClaimPicturesList from './ClaimPicturesList';
import { DOCUMENT_TYPES } from '../../utils/claimHelpers';

/**
 * Documents checklist + Pictures preview grid.
 * Rendered at the bottom of the form content area.
 */
export default function ClaimDocuments({ claim, formData, editMode, handleChange }) {
  const ro = !editMode;
  return (
    <>
      <Section>
        <FieldLabel>Documents</FieldLabel>
        <div className="space-y-1.5 mt-1">
          {DOCUMENT_TYPES.map(({ label, field }) => (
            <div key={field} className="flex items-center space-x-2">
              <Checkbox
                id={`edit-doc-${field}`}
                checked={!!formData[field]}
                onCheckedChange={ro ? undefined : (checked) => handleChange(field, checked)}
                disabled={ro}
                className="w-4 h-4 border-2 shrink-0"
                data-testid={`edit-doc-${field}`}
              />
              <Label htmlFor={`edit-doc-${field}`} className="text-xs text-gray-600 cursor-pointer leading-tight">{label}</Label>
            </div>
          ))}
        </div>
      </Section>

      <div>
        <FieldLabel>Pictures</FieldLabel>
        <ClaimPicturesList claim={claim} />
      </div>
    </>
  );
}
